/*
 * Cerwin-Vega — Product Manuals page (pages/download_manuals)
 * v2 — catalog-driven. Rebuilt 2026-10-29 from the files in Shopify > Content > Files.
 *
 * HOW TO ADD OR CHANGE A DOCUMENT
 *   Find the series below and add a line to its docs list:
 *     ["Document title", "File_name_exactly_as_in_Shopify_Files.pdf"]
 *   - Series-wide documents (owner's manual, brochure) go in the 4th field.
 *   - Model-specific documents (one sheets, spec sheets) go in the 5th field,
 *     keyed by the model name.
 *   - A model listed in the 3rd field shows in the Model dropdown.
 *   Any download already on the page that is NOT in this catalog is still kept
 *   and listed under "Other Downloads", so nothing on the page is lost.
 *
 * Entry format:
 *   [ "Collection", "Series", ["MODEL1","MODEL2"],
 *     [ ["Series doc title","file.pdf"], ... ],
 *     { "MODEL1": [ ["Model doc title","file.pdf"] ], ... } ]
 */
var CV_FILES = "https://cdn.shopify.com/s/files/1/0645/1711/1988/files/";

/* Old links still in the page HTML that are dead or replaced by a newer file
   in the catalog. They are not shown under "Other Downloads". */
var CV_SKIP = [
  "ST69CX_Owner_s_Manual.pdf",                 /* 404 - replaced by Manual-ST69CX.pdf */
  "HED_Amplifier.pdf",                         /* replaced by Manual-HED_Amplifier.pdf (2026) */
  "HED-Speakers-Owner_s_Manual_7add1471-5c90-4f18-b960-7d74d8f44e07.pdf", /* replaced by updated HED speaker manual */
  "hed_series.pdf",
  "CVM_MIXER_REV_E.pdf",                       /* replaced by REV F */
  "Vega_Mini_Manual_V8.pdf",                   /* replaced by Vega_Mini_User_Manual.pdf */
  "UTV65_ONESHEET.pdf", "UTV65LED_ONESHEET.pdf", "VPASV8_Onesheet.pdf",
  "CVP800.2D.pdf",
  "CVP10S4_One_Sheet_updated_footer_77161f46-4744-4c89-a9e7-4882c5602aa6.pdf",
  "XM65W_MANUAL_compressed.pdf", "S9750.1D_One_Sheet.pdf", "SPCL182.pdf"
];

var CV_MANUALS = [
  /* ============================ PRO AUDIO ============================ */
  ["Pro Audio", "CVE Series Powered Speakers", ["CVE-10", "CVE-12", "CVE-15", "CVE-18S"],
    [["CVE Series Owner's Manual (English)", "Instruction_Manual_-_CVE_Series_-_EN.pdf"],
     ["CVE Series Manual (Spanish)", "Instruction_Manual_-_CVE_Series_Spanish.pdf"],
     ["CVE Series Manual (French)", "Instruction_Manual_-_CVE_Series_French.pdf"],
     ["CVE Series Manual (German)", "Instruction_Manual_-_CVE_Series_German.pdf"],
     ["CVE Series Manual (Portuguese)", "Instruction_Manual_CVE_Series_Portuguese.pdf"],
     ["CVE Series Manual (Japanese)", "Instruction_Manual_-_CVE_Series_Japanese.pdf"],
     ["CVE Series Manual (Chinese)", "Instruction_Manual_-_CVE_Series_Chinese.pdf"],
     ["CVE Wall Mount Bracket Manual (English)", "Instruction_Manual_-_wall_mount_bracket_-_CVE_Series_English.pdf"],
     ["CVE Wall Mount Bracket Manual (French)", "Instruction_Manual_-_wall_mount_bracket_-_CVE_Series_French.pdf"],
     ["CVE Wall Mount Bracket Manual (German)", "Instruction_Manual_-_wall_mount_bracket_-_CVE_Series_German.pdf"],
     ["CVE Wall Mount Bracket Manual (Japanese)", "Instruction_Manual_-_wall_mount_bracket_-_CVE_Series_Japanese.pdf"],
     ["CVE Wall Mount Bracket Manual (Chinese)", "Instruction_Manual_-_wall_mount_bracket_-_CVE_Series_Chinese.pdf"],
     ["CVE Series Brochure", "CVE_Series_Brochure.pdf"]],
    {"CVE-10": [["CVE-10 RED Certificate", "DDT-CE23072822-2E01_CVE-10_RED_Certificate.pdf"]]}],

  ["Pro Audio", "CVX Series Powered Speakers & Subwoofers", ["CVX-10", "CVX-15", "CVX-18S", "CVX-21S", "CVX-218S", "CVX-221S"],
    [["CVX Series User Manual (English)", "CVX-Series-User-Manual-English.pdf"],
     ["CVX Series User Manual (Spanish)", "CVX-Series-User-Manual-Spanish.pdf"],
     ["CVX Series User Manual (French)", "CVX-Series-User-Manual-French.pdf"],
     ["CVX Series User Manual (German)", "CVX-Series-User-Manual-German.pdf"],
     ["CVX Series User Manual (Portuguese)", "CVX_Series_User_Manual_Portuguese.pdf"],
     ["CVX Series User Manual (Japanese)", "CVX-Series-User-Manual-Japanese.pdf"],
     ["CVX Series User Manual (Chinese)", "CVX-Series-User-Manual-Chinese.pdf"],
     ["CVX Quick Start Guide (EN/FR/ES/DE)", "CVX-Quick-Start-Guide-ENG-FRA-ESP-GER-RevA1.pdf"],
     ["CVX Series Brochure", "cvx_brochure.pdf"]],
    {}],

  ["Pro Audio", "CVXL Series Loudspeakers", ["CVXL-112", "CVXL-115", "CVXL-118S", "CVXL-215", "CVXL-218S"],
    [["CVXL Series Manual (English)", "CVXL_MANUAL.pdf"],
     ["CVXL Series Manual (Portuguese)", "CVXL_Series_Manual_Portuguese.pdf"],
     ["CVXL Series Specifications", "CVXL_SPECS.pdf"]],
    {}],

  ["Pro Audio", "CVi Portable Speakers", ["CVI-122M", "CVI-152", "CVI-252", "CVI-118S", "CVI-218S"],
    [["CVi Series Manual", "CVI_Manual.pdf"],
     ["CVi Series Cut Sheet", "CVI_CutSheet.pdf"]],
    {"CVI-122M": [["CVI-122M Datasheet", "cvi122m_datasheet.pdf"]],
     "CVI-152": [["CVI-152 Datasheet", "CVI152_datasheet.pdf"]],
     "CVI-252": [["CVI-252 Datasheet", "CVI252_datasheet.pdf"]],
     "CVI-118S": [["CVI-118S Datasheet", "CVI118s_datasheet.pdf"]],
     "CVI-218S": [["CVI-218S Datasheet", "CVI218s_datasheet.pdf"]]}],

  ["Pro Audio", "Intense V2 Portable Speakers", ["INT-152V2", "INT-252V2", "INT-118SV2"],
    [["Intense V2 Series Manual", "INTENSE_SERIES_V2_MANUAL.pdf"]],
    {"INT-152V2": [["INT-152V2 Spec Sheet", "INT152V2_spec_sheet.pdf"]],
     "INT-252V2": [["INT-252V2 Spec Sheet", "INT252-V2_spec_sheet.pdf"]],
     "INT-118SV2": [["INT-118SV2 Spec Sheet", "INT118S-V2_spec_sheet.pdf"]]}],

  ["Pro Audio", "Folded Horn Subwoofers", ["EL-36D", "EL-36DP"],
    [["EL-36D / EL-36DP Manual", "EL36D-EL36DP_Manual.pdf"],
     ["Folded Horns Cut Sheet", "FoldedHorns_cutsheet.pdf"]],
    {}],

  ["Pro Audio", "CV PRO Line Array, Column & Monitor Systems", ["CV PRO Catalog"],
    [["CV PRO Catalog", "CV_PRO_Catalog_Rev_A_web.pdf"]],
    {}],

  ["Pro Audio", "CV2 / CV4 Power Amplifiers", ["CV2-22H", "CV2-33H", "CV2-46H", "CV4-8H", "CV4-18H"],
    [["CV2 / CV4 Amplifier Manual", "CV2_CV4_AMPLIFIER_MANUAL_9c36d8b5-4bd8-4d13-80e0-f48d833c2fea.pdf"],
     ["CV2 / CV4 Quick Start Guide", "CV2_CV4_AMPLIFIER-QUICK_START_GUIDE_39c62d50-0615-41f3-be2a-31e27b751ffe.pdf"],
     ["CV2 / CV4 Cut Sheet", "CV2_CV4_Amplifier-Cut_sheet-Rev_A.pdf"]],
    {}],

  ["Pro Audio", "Vega Studio Monitors", ["VEGA4S", "VEGA6S", "VEGA8S", "VEGA10S"],
    [["Vega Studio Monitors Manual (English)", "VEGA_STUDIO_MONITORS_REV_D_ENGLISH.pdf"],
     ["Vega Studio Monitors Manual (Spanish)", "VEGA_STUDIO_MONITORS_REV_D_SPANISH.pdf"],
     ["Vega Studio Monitors Manual (French)", "VEGA_STUDIO_MONITORS_REV_D_FRENCH.pdf"],
     ["Vega Studio Monitors Manual (Portuguese)", "VEGA_STUDIO_MONITORS_REV_D_PORTUGUESE.pdf"],
     ["Vega Series Monitors Introduction (English)", "VEGA_SERIES_MONITORS_INTRODUCTION_ENGLISH.pdf"],
     ["Vega Series Monitors Introduction (Spanish)", "VEGA_SERIES_MONITORS_INTRODUCTION_SPANISH.pdf"],
     ["Vega Series Monitors Introduction (French)", "VEGA_SERIES_MONITORS_INTRODUCTION_FRENCH.pdf"],
     ["Vega Studio Monitors Cut Sheet", "Vega_Studio_Monitors_Cut_Sheet_Rev.pdf"]],
    {}],

  ["Pro Audio", "CVM Mixers", ["CVM8", "CVM10", "CVM12", "CVM16"],
    [["CVM Mixer Manual", "CVM_MIXER_REV_F.pdf"],
     ["CVM Mixer Manual (Portuguese)", "CVM_Series_Mixers_Manual_-_Portuguese.pdf"],
     ["CVM Mixer Cut Sheet", "CVM_Mixer_Cut_Sheet.pdf"]],
    {}],

  ["Pro Audio", "Headphones & Earbuds", ["HB1", "HB2", "VegaBuds"],
    [],
    {"HB1": [["HB1 Manual", "HB1_Manual.pdf"], ["HB Headphones Cut Sheet", "HB_Headphones_Cut_Sheet.pdf"]],
     "HB2": [["HB2 Manual", "HB2_Manual.pdf"], ["HB Headphones Cut Sheet", "HB_Headphones_Cut_Sheet.pdf"]],
     "VegaBuds": [["VegaBuds EB1 Manual", "VEGABUDS_EB1_ANC_ENC_Manual_8256af37-14d6-4f0d-868b-d827cf45b522.pdf"],
                  ["VegaBuds One Sheet", "VegaBuds_One_Sheet.pdf"]]}],

  /* ============================ HOME AUDIO ============================ */
  ["Home Audio", "SL Series", ["SL-5M", "SL-8", "SL-12", "SL-15", "SL-28", "SL-25C", "SL-45C", "SL-10S"],
    [["SL Series Manual (EN/FR/ES/DE/CN)", "SL_SERIES_REV_B_EN-FR-ES-DE-CN_WEB.pdf"],
     ["SL Series Cut Sheet", "SL-Series-CutSheet.pdf"]],
    {}],

  ["Home Audio", "XLS Series", ["XLS-6", "XLS-6C", "XLS-12", "XLS-15", "XLS-28", "XLS-215", "XLS-12S", "XLS-15S"],
    [["XLS Series Manual", "xls_series_xls12.pdf"],
     ["XLS Brochure", "XLS_Brochure.pdf"],
     ["XLS Review Reprint (Audio Video Revolution)", "AudioVideoRevolution-XLS-Review-Reprint.pdf"]],
    {"XLS-12S": [["XLS Subwoofer Manual", "MANUAL_XLSSUBS.pdf"]],
     "XLS-15S": [["XLS Subwoofer Manual", "MANUAL_XLSSUBS.pdf"]]}],

  ["Home Audio", "LA Series", ["LA14", "LA24", "LA44", "LA165", "LA265", "LA365", "LA110"],
    [["LA Series Manual (EN/FR/ES)", "LASeriesREV_E_Eng_French_Spanish.pdf"],
     ["LA Series Cut Sheet", "LA_Series_Cut_Sheet.pdf"]],
    {}],

  ["Home Audio", "Portable Bluetooth Speakers", ["VegaMini"],
    [],
    {"VegaMini": [["VegaMini User Manual", "Vega_Mini_User_Manual.pdf"],
                  ["VegaMini One Sheet", "VEGA_MINI.pdf"]]}],

  ["Home Audio", "Headphones & Earbuds", ["HB1", "HB2", "VegaBuds"],
    [],
    {"HB1": [["HB1 Manual", "HB1_Manual.pdf"], ["HB Headphones Cut Sheet", "HB_Headphones_Cut_Sheet.pdf"]],
     "HB2": [["HB2 Manual", "HB2_Manual.pdf"], ["HB Headphones Cut Sheet", "HB_Headphones_Cut_Sheet.pdf"]],
     "VegaBuds": [["VegaBuds EB1 Manual", "VEGABUDS_EB1_ANC_ENC_Manual_8256af37-14d6-4f0d-868b-d827cf45b522.pdf"],
                  ["VegaBuds One Sheet", "VegaBuds_One_Sheet.pdf"]]}],

  /* ============================ AMPLIFIER ============================ */
  ["Amplifier", "HED Amplifier", ["H400.2D", "H440.4D", "H800.4D", "H800.5D", "H900.6D", "H1000.1D", "H1500.1D"],
    [["HED Amplifier Owner's Manual", "Manual-HED_Amplifier.pdf"]],
    {"H400.2D": [["H400.2D One Sheet", "H400.2D_ONE_SHEET.pdf"]],
     "H440.4D": [["H440.4D One Sheet", "H440.4D_compressed.pdf"]],
     "H800.4D": [["H800.4D One Sheet", "H800.4D_compressed.pdf"]],
     "H800.5D": [["H800.5D One Sheet", "H800.5D_compressed.pdf"]],
     "H900.6D": [["H900.6D One Sheet", "H900.6D_compressed.pdf"]],
     "H1000.1D": [["H1000.1D One Sheet", "H1000.1D_compressed.pdf"]],
     "H1500.1D": [["H1500.1D One Sheet", "H1500.1D_compressed.pdf"]]}],

  ["Amplifier", "Vega Amplifier", ["VCU81", "VCU82", "VCU84", "VCU85", "VCU86"],
    [["Vega Amplifier Owner's Manual", "Vega_Amplifier.pdf"]],
    {"VCU81": [["VCU81 One Sheet", "VCU81.pdf"]],
     "VCU82": [["VCU82 One Sheet", "VCU82.pdf"]],
     "VCU84": [["VCU84 One Sheet", "VCU84.pdf"]],
     "VCU85": [["VCU85 One Sheet", "VCU85.pdf"]],
     "VCU86": [["VCU86 One Sheet", "VCU86.pdf"]]}],

  ["Amplifier", "XED Amplifier", ["XED3001D", "XED3002D", "XED4004D", "XED6001D", "XED6004D", "XED8001D", "XED8005D", "XED11001D"],
    [["XED Amplifier Owner's Manual", "XED_Amplifier.pdf"]],
    {"XED3001D": [["XED3001D One Sheet", "XED3001D.pdf"]],
     "XED3002D": [["XED3002D One Sheet", "XED3002D.pdf"]],
     "XED4004D": [["XED4004D One Sheet", "XED4004D.pdf"]],
     "XED6001D": [["XED6001D One Sheet", "XED6001D.pdf"]],
     "XED6004D": [["XED6004D One Sheet", "XED6004D.pdf"]],
     "XED8001D": [["XED8001D One Sheet", "XED8001D.pdf"]],
     "XED8005D": [["XED8005D One Sheet", "XED8005D.pdf"]],
     "XED11001D": [["XED11001D One Sheet", "XED11001D.pdf"]]}],

  ["Amplifier", "CVP Amplifier", ["CVP800.2D", "CVP1200.4D", "CVP1600.1D", "CVP1600.4D", "CVP2000.1D", "CVP2500.5D", "CVP3000.1D"],
    [["CVP Amplifier Owner's Manual", "CVP_Amplifier.pdf"]],
    {"CVP800.2D": [["CVP800.2D One Sheet", "CVP800.2D_17e6e155-d4fb-4cc3-84b4-4edb0e13d619.pdf"]],
     "CVP1200.4D": [["CVP1200.4D One Sheet", "CVP1200.4D.pdf"]],
     "CVP1600.1D": [["CVP1600.1D One Sheet", "CVP1600.1D.pdf"]],
     "CVP1600.4D": [["CVP1600.4D One Sheet", "CVP1600.4D.pdf"]],
     "CVP2000.1D": [["CVP2000.1D One Sheet", "CVP2000.1D.pdf"]],
     "CVP2500.5D": [["CVP2500.5D One Sheet", "CVP2500.5D.pdf"]],
     "CVP3000.1D": [["CVP3000.1D One Sheet", "CVP3000.1D.pdf"]]}],

  ["Amplifier", "CVP Performance Amplifier", ["CVP700.2", "CVP1400.4", "CVP2400.1", "CVP2400.4", "CVP2700.5", "CVP3600.1"],
    [["CVP Series Amplifier Manual", "CVP_Series_Amplifier-manual.pdf"]],
    {"CVP700.2": [["CVP700.2 One Sheet", "CVP700.2_ONESHEET_6a631caa-e9ca-485d-95fe-0a522cb8d8fa.pdf"]],
     "CVP1400.4": [["CVP1400.4 One Sheet", "CVP1400.4_ONESHEET.pdf"]],
     "CVP2400.1": [["CVP2400.1 One Sheet", "CVP2400.1_ONESHEET_bdb95697-efa5-4345-9e81-464d8f186152.pdf"]],
     "CVP2400.4": [["CVP2400.4 One Sheet", "CVP2400.4_ONESHEET.pdf"]],
     "CVP2700.5": [["CVP2700.5 One Sheet", "CVP2700.5_ONESHEET_9794ccb2-bfd5-43d8-8bff-c35df507f7dd.pdf"]],
     "CVP3600.1": [["CVP3600.1 One Sheet", "CVP3600.1_ONESHEET_2290461c-c5cb-4834-af7b-48db4d90dab2.pdf"]]}],

  ["Amplifier", "CVPM Amplifier", ["CVPM400.4D", "CVPM1000.1D"],
    [["CVPM Amplifier Owner's Manual", "CVPM_Amplifier.pdf"]],
    {"CVPM400.4D": [["CVPM400.4D One Sheet", "i_compressedi_One_Sheet-CVPM400.4D.pdf"]],
     "CVPM1000.1D": [["CVPM1000.1D One Sheet", "i_compressedi_One_Sheet-CVPM1000.1D.pdf"]]}],

  ["Amplifier", "CV PRO Amplifier", ["CVPRO2K4", "CVPRO3K", "CVPRO5K"],
    [["CV PRO Series Amplifier Manual", "CVPRO_SERIES_AMPLIFIERS_MANUAL.pdf"],
     ["Pro Amplifier Owner's Manual (previous edition)", "Pro_Amplifier.pdf"]],
    {"CVPRO2K4": [["CVPRO2K4 One Sheet", "CVPRO2K4_ONESHEET.pdf"]],
     "CVPRO3K": [["CVPRO3K One Sheet", "CVPRO3K_ONESHEET.pdf"]],
     "CVPRO5K": [["CVPRO5K One Sheet", "CVPRO5K_ONESHEET.pdf"]]}],

  ["Amplifier", "Stroker Pro Amplifier", ["SPRO1600.1D", "SPRO2100.1D", "SPRO2600.1D"],
    [["Stroker Pro Amplifier Owner's Manual", "SPRO-Amp-Manual.pdf"]],
    {"SPRO2100.1D": [["SPRO2100.1D One Sheet", "SPRO2100.1D_ONESHEET_b47cd409-f55b-478f-acc2-0fc3303c8c7d.pdf"]]}],

  ["Amplifier", "Stroker Amplifier", ["S9500.2D", "S9600.4D", "S9750.1D", "S91000.1D", "S91100.5D", "S91500.1D"],
    [["Stroker Amplifier Owner's Manual", "STKR_AMP-Manual-compressed.pdf"]],
    {"S9500.2D": [["S9500.2D One Sheet", "S9500.2D_One_Sheet.pdf"]],
     "S9600.4D": [["S9600.4D One Sheet", "S9600.4D_One_Sheet.pdf"]],
     "S9750.1D": [["S9750.1D One Sheet", "S9750.1D_onesheet.pdf"]],
     "S91000.1D": [["S91000.1D One Sheet", "S91000.1D_One_Sheet.pdf"]],
     "S91100.5D": [["S91100.5D One Sheet", "S91100.5D_One_Sheet.pdf"]]}],

  ["Amplifier", "RPM Stroker Marine Amplifier", ["SRPM700.2D / 700.2DW", "SRPM700.4D / 700.4DW", "SRPM750.1D / 750.1DW", "SRPM1000.1D / 1000.1DW", "SRPM1100.5D / 1100.5DW"],
    [["RPM Stroker Amplifier Owner's Manual", "RPM_Stroker_Amplifier.pdf"]],
    {"SRPM700.2D / 700.2DW": [["SRPM700.2DW One Sheet", "SRPM700.2DW.pdf"]],
     "SRPM700.4D / 700.4DW": [["SRPM700.4DW One Sheet", "SRPM700.4DW.pdf"]],
     "SRPM750.1D / 750.1DW": [["SRPM750.1DW One Sheet", "SRPM750.1DW.pdf"]],
     "SRPM1000.1D / 1000.1DW": [["SRPM1000.1DW One Sheet", "SRPM1000.1DW.pdf"]],
     "SRPM1100.5D / 1100.5DW": [["SRPM1100.5DW One Sheet", "SRPM1100.5DW.pdf"]]}],

  ["Amplifier", "RPM HED Marine Amplifier", ["HRPM300.2D", "HRPM350.1D", "HRPM360.4D"],
    [["RPM HED Amplifier Owner's Manual", "HRPM_HRPM360.4D_Owner_s_Manual.pdf"]],
    {"HRPM300.2D": [["HRPM300.2D One Sheet", "HRPM300.2D.pdf"]],
     "HRPM350.1D": [["HRPM350.1D One Sheet", "HRPM350.1D.pdf"]],
     "HRPM360.4D": [["HRPM360.4D One Sheet", "HRPM360.4D.pdf"]]}],

  ["Amplifier", "Stealth Bomber Amplifier", ["B51", "B52", "B54", "B55"],
    [["Stealth Bomber Amplifier Owner's Manual", "Stealth_Bomber_Manual.pdf"]],
    {"B51": [["B51 One Sheet", "B51_One_Sheet_compressed.pdf"]],
     "B52": [["B52 One Sheet", "B52_One_Sheet_compressed.pdf"]],
     "B54": [["B54 One Sheet", "B54_One_Sheet_compressed.pdf"]],
     "B55": [["B55 One Sheet", "B55_One_Sheet_compressed.pdf"]]}],

  ["Amplifier", "Digital Sound Processors", ["CVDSP66", "CVDSP66LCD", "CVDSP88"],
    [],
    {"CVDSP66": [["CVDSP66 Quick Guide", "CVDSP66_Quickguide_c26e6327-f9a6-4b29-a0ee-666075ee84ae.pdf"],
                 ["CVDSP66 PC Software (ZIP)", "CVDSP66_App_Download_1.zip"],
                 ["CVDSP66 One Sheet", "CVDSP66.pdf"]],
     "CVDSP66LCD": [["CVDSP66LCD One Sheet", "CVDSP66LCD.pdf"],
                    ["CVDSP66 Quick Guide", "CVDSP66_Quickguide_c26e6327-f9a6-4b29-a0ee-666075ee84ae.pdf"]],
     "CVDSP88": [["CVDSP88 Quick Guide", "i_compressedi_CVDSP88_Quickguide.pdf"],
                 ["CVDSP88 PC Software (ZIP)", "CVDSP88_App_Download.zip"],
                 ["CVDSP88 One Sheet", "CVDSP88.pdf"]]}],

  /* ============================ SPEAKER ============================ */
  ["Speaker", "Vega Speakers", ["V465", "V465C", "V468", "V469", "Vega 2024 Edition Coaxials", "Vega Component Sets", "VT1 Tweeter"],
    [["Vega Series Speaker Manual", "vega_series_speaker_manual_7c37a1b9-c44a-45d2-8c14-15fa3a0339ef.pdf"],
     ["Vega Series Speakers One Sheet", "VEGA_SERIES_SPEAKERS_ONESHEET.pdf"]],
    {"V465C": [["V465C One Sheet", "ONE_SHEET-V465C.pdf"]]}],

  ["Speaker", "HED Speakers", ["H735", "H740", "H7410", "H746", "H752", "H7652", "H7653", "H7683", "H7692", "H7693", "H7694", "H7525C", "H765C", "H7TAK", "HED 2025 Edition"],
    [["HED Series Speaker Manual", "i_Updatedi_HED_series_speaker_manual.pdf"],
     ["HED Series Speakers One Sheet", "i_compressedi_HED_SERIES_SPEAKERS_ONESHEET.pdf"]],
    {"H735": [["H735 One Sheet", "i_compressedi_ONE_SHEET-H735.pdf"]],
     "H740": [["H740 One Sheet", "i_compressedi_ONE_SHEET-H740.pdf"]],
     "H7410": [["H7410 One Sheet", "i_compressedi_ONE_SHEET-H7410.pdf"]],
     "H746": [["H746 One Sheet", "i_compressedi_ONE_SHEET-H746.pdf"]],
     "H752": [["H752 One Sheet", "i_compressedi_ONE_SHEET-H752.pdf"]],
     "H7652": [["H7652 One Sheet", "i_compressedi_ONE_SHEET-H7652.pdf"]],
     "H7653": [["H7653 One Sheet", "i_compressedi_ONE_SHEET-H7653.pdf"]],
     "H7683": [["H7683 One Sheet", "i_compressedi_ONE_SHEET-H7683.pdf"]],
     "H7692": [["H7692 One Sheet", "i_compressedi_ONE_SHEET-H7692.pdf"]],
     "H7693": [["H7693 One Sheet", "i_compressedi_ONE_SHEET-H7693.pdf"]],
     "H7694": [["H7694 One Sheet", "i_compressedi_ONE_SHEET-H7694.pdf"]],
     "H7525C": [["H7525C One Sheet", "i_compressedi_ONE_SHEET-H7525C.pdf"]],
     "H765C": [["H765C One Sheet", "i_compressedi_ONE_SHEET-H765C.pdf"]],
     "H7TAK": [["H7TAK One Sheet", "i_compressedi_ONE_SHEET-H7TAK.pdf"]]}],

  ["Speaker", "HED Pro Speakers", ["HED65P", "HED69P", "HED8P", "HEDPS1", "HEDPS65", "HEDPS69", "HEDPS8"],
    [],
    {"HED65P": [["HED Pro Manual", "i_compressedi_HED_PRO-MANUAL-Rev_1-8.22.2025.pdf"], ["HED65P One Sheet", "i_compressedi_HED65P-One_sheet-8.21.2025_1.pdf"]],
     "HED69P": [["HED Pro Manual", "i_compressedi_HED_PRO-MANUAL-Rev_1-8.22.2025.pdf"], ["HED69P One Sheet", "i_compressedi_HED69P-One_sheet-8.21.2025_3.pdf"]],
     "HED8P": [["HED Pro Manual", "i_compressedi_HED_PRO-MANUAL-Rev_1-8.22.2025.pdf"], ["HED8P One Sheet", "i_compressedi_HED8P-One_sheet-8.21.2025_2.pdf"]],
     "HEDPS1": [["HEDPS Series Manual", "HEDPS_SERIES_SPEAKERS_MANUAL.pdf"], ["HEDPS Series One Sheet", "HEDPS_SERIES_ONE_SHEET.pdf"]],
     "HEDPS65": [["HEDPS Series Manual", "HEDPS_SERIES_SPEAKERS_MANUAL.pdf"], ["HEDPS Series One Sheet", "HEDPS_SERIES_ONE_SHEET.pdf"]],
     "HEDPS69": [["HEDPS Series Manual", "HEDPS_SERIES_SPEAKERS_MANUAL.pdf"], ["HEDPS Series One Sheet", "HEDPS_SERIES_ONE_SHEET.pdf"]],
     "HEDPS8": [["HEDPS Series Manual", "HEDPS_SERIES_SPEAKERS_MANUAL.pdf"], ["HEDPS Series One Sheet", "HEDPS_SERIES_ONE_SHEET.pdf"]]}],

  ["Speaker", "XED Speakers", ["XED42", "XED46", "XED52", "XED57", "XED62", "XED693", "XED525C", "XED650C", "XED1T"],
    [["XED Speakers Owner's Manual", "XED-Speakers-Owner_s_Manual_-Rev_B.pdf"]],
    {"XED42": [["XED42 One Sheet", "i_compressedi_ONE_SHEET-XED42.pdf"]],
     "XED46": [["XED46 One Sheet", "i_compressedi_ONE_SHEET-XED46.pdf"]],
     "XED52": [["XED52 One Sheet", "i_compressedi_ONE_SHEET-XED52.pdf"]],
     "XED57": [["XED57 One Sheet", "i_compressedi_ONE_SHEET-XED57.pdf"]],
     "XED62": [["XED62 One Sheet", "i_compressedi_ONE_SHEET-XED62.pdf"]],
     "XED693": [["XED693 One Sheet", "i_compressedi_ONE_SHEET-XED693.pdf"]],
     "XED525C": [["XED525C One Sheet", "One_sheet-XED525C.pdf"]],
     "XED650C": [["XED650C One Sheet", "One_sheet-XED650C.pdf"]],
     "XED1T": [["XED1T Manual", "XED1T_-_Manual_-_Final_Pages.pdf"], ["XED1T One Sheet", "i_compressedi_ONE_SHEET-XED1T.pdf"]]}],

  ["Speaker", "Stroker Speakers", ["ST65C", "ST69CX", "ST692CX2"],
    [],
    {"ST65C": [["ST65C / SPRO65C Manual", "ST65C-SPRO65C-MANUAL_PAGES.pdf"], ["ST65C One Sheet", "ONE_SHEET-ST65C.pdf"]],
     "ST69CX": [["ST69CX Manual", "Manual-ST69CX.pdf"], ["ST69CX One Sheet", "i_compressedi_ONE_SHEET-ST69CX.pdf"]],
     "ST692CX2": [["ST692CX2 Owner's Manual", "i_compressedi_ST692CX2_Owner_s_Manual.pdf"], ["ST692CX2 One Sheet", "i_compressedi_ONE_SHEET-ST692CX2.pdf"]]}],

  ["Speaker", "Stroker Pro Speakers", ["CVMPCL6.5", "CVMPCL8.0", "CVMPCL10", "CVMPCL1.0T", "SPRO65C"],
    [["Stroker Pro Speaker Owner's Manual", "Stroker_Pro_speaker_Owner_s_Manual.pdf"]],
    {"SPRO65C": [["ST65C / SPRO65C Manual", "ST65C-SPRO65C-MANUAL_PAGES.pdf"]]}],

  ["Speaker", "PH Pro Horn Speakers", ["PH654", "PH694", "PH84", "PH Series Grills"],
    [["PH Speakers Owner's Manual", "PH-Speakers-Owner_s_Manual.pdf"]],
    {"PH654": [["PH654 One Sheet", "PH654_compressed.pdf"]],
     "PH694": [["PH694 One Sheet", "PH694_compressed.pdf"]],
     "PH84": [["PH84 One Sheet", "PH84_compressed.pdf"]],
     "PH Series Grills": [["PH Series Grills One Sheet", "GRL69PH_GRL8PH_GRL65PH_onesheet.pdf"]]}],

  ["Speaker", "Pro Tweeters", ["P1T", "P175T", "P75T", "P1SRT", "P1SWT"],
    [["CV Tweeter Owner's Manual", "CV-Tweeter-Owner_s_Manual.pdf"]],
    {"P1T": [["P1T One Sheet", "P1T.pdf"]],
     "P175T": [["P175T One Sheet", "P175T.pdf"]],
     "P75T": [["P75T One Sheet", "P75T.pdf"]],
     "P1SRT": [["P1SRT One Sheet", "P1SRT.pdf"]],
     "P1SWT": [["P1SWT One Sheet", "P1SWT.pdf"]]}],

  ["Speaker", "CVP Pro Speakers", ["CVP65", "CVP69", "CVP8"],
    [["CV Pro Speaker Owner's Manual", "CVPro_Owner_s_Manual.pdf"]],
    {}],

  ["Speaker", "CVPX Horn-Loaded Speakers", ["CVPX1", "CVPX65", "CVPX69", "CVPX8"],
    [["CVPX Series One Sheet", "CVPX_one_sheet.pdf"]],
    {"CVPX1": [["CVPX1 One Sheet", "CVPX1_One_Sheet_updated_footer.pdf"]],
     "CVPX65": [["CVPX65 One Sheet", "CVPX65_One_Sheet_updated_footer.pdf"]],
     "CVPX69": [["CVPX69 One Sheet", "CVPX69_One_Sheet_updated_footer.pdf"]],
     "CVPX8": [["CVPX8 One Sheet", "CVPX8_One_Sheet_updated_footer.pdf"]]}],

  ["Speaker", "RPM Stroker Marine Speakers", ["SM52", "SM65", "SM8", "SM65F4", "SM69F4", "SM8F4", "SH65F4", "SH8F4", "SH10F4", "SL65F4 / SL8F4"],
    [],
    {"SM52": [["SM52 / SM65 / SM8 Owner's Manual", "RPM-VEGA-STKR-SM_65-52-8_Owner_s_Manual.pdf"]],
     "SM65": [["SM52 / SM65 / SM8 Owner's Manual", "RPM-VEGA-STKR-SM_65-52-8_Owner_s_Manual.pdf"]],
     "SM8": [["SM52 / SM65 / SM8 Owner's Manual", "RPM-VEGA-STKR-SM_65-52-8_Owner_s_Manual.pdf"]],
     "SM65F4": [["SMF4 Series Owner's Manual", "SMF-SPKR-SMF4_series_Owner_s_Manual.pdf"], ["SM65F4 One Sheet", "SM65F4.pdf"]],
     "SM69F4": [["SMF4 Series Owner's Manual", "SMF-SPKR-SMF4_series_Owner_s_Manual.pdf"], ["SM69F4 One Sheet", "SM69F4.pdf"]],
     "SM8F4": [["SMF4 Series Owner's Manual", "SMF-SPKR-SMF4_series_Owner_s_Manual.pdf"], ["SM8F4 One Sheet", "SM8F4.pdf"]],
     "SH65F4": [["Pod Speaker Manual", "CV_POD_SPKR_Manual_Pages_-_Compressed.pdf"], ["SH65F4B One Sheet", "SH65F4B.pdf"], ["SH65F4W One Sheet", "SH65F4W.pdf"]],
     "SH8F4": [["Pod Speaker Manual", "CV_POD_SPKR_Manual_Pages_-_Compressed.pdf"], ["SH8F4B One Sheet", "SH8F4B.pdf"], ["SH8F4W One Sheet", "SH8F4W.pdf"]],
     "SH10F4": [["Pod Speaker Manual", "CV_POD_SPKR_Manual_Pages_-_Compressed.pdf"], ["SH10F4B One Sheet", "SH10F4B.pdf"], ["SH10F4W One Sheet", "SH10F4W.pdf"]],
     "SL65F4 / SL8F4": [["Long Pod Speaker Owner's Manual", "CV_Long_SL_Series_Owner_s_Manual.pdf"]]}],

  ["Speaker", "RPM Vega Marine Speakers", ["VM65", "VM8"],
    [["VM65 / VM8 Owner's Manual", "RPM-VEGA-STKR-SM_65-52-8_Owner_s_Manual.pdf"]],
    {}],

  ["Speaker", "RPM XED Marine Speakers & Soundbars", ["XM65W", "XM69W", "SB3X", "SB4X"],
    [],
    {"XM65W": [["XM65W Manual", "XM65W_MANUAL_compressed_4bdca6dc-8fac-408b-aa1b-6564843184c6.pdf"]],
     "XM69W": [["XM69W Manual", "XM69W_MANUAL.pdf"], ["XM69W One Sheet", "XM69W.pdf"]],
     "SB3X": [["XED Soundbar User Manual", "XED_SERIES_SOUNDBARS_USER_MANUAL.pdf"], ["XED Soundbar (LED) User Manual", "XED_SERIES_SOUNDBARS_LED_USER_MANUAL.pdf"]],
     "SB4X": [["XED Soundbar User Manual", "XED_SERIES_SOUNDBARS_USER_MANUAL.pdf"], ["XED Soundbar (LED) User Manual", "XED_SERIES_SOUNDBARS_LED_USER_MANUAL.pdf"], ["SB4X One Sheet", "SB4X.pdf"]]}],

  ["Speaker", "UTV Powered Speakers", ["UTV65", "UTV65LED", "UTV8LED"],
    [["UTV Series Manual", "Final-Manual-UTV_SERIES-Rev_A.pdf"]],
    {"UTV65": [["UTV65 One Sheet", "UTV65_One_Sheet_updated_footer.pdf"]],
     "UTV65LED": [["UTV65LED One Sheet", "UTV65LED_One_Sheet_updated_footer.pdf"]],
     "UTV8LED": [["UTV8LED Manual", "Manual-UTV8LED.pdf"], ["UTV8LED One Sheet", "One_Sheet-UTV8LED.pdf"]]}],

  ["Speaker", "Jeep Speaker Kits", ["RVJP650E", "RVJP69", "RVJP690E"],
    [],
    {"RVJP650E": [["RVJP650E One Sheet", "RVJP65OE.pdf"]],
     "RVJP69": [["RVJP69 One Sheet", "RVJP69.pdf"]],
     "RVJP690E": [["RVJP690E One Sheet", "RVJP69OE.pdf"]]}],

  /* ============================ SUBWOOFER ============================ */
  ["Subwoofer", "Vega Subwoofers", ["V82DV2", "V84DV2", "V102DV2", "V104DV2", "V122DV2", "V124DV2", "V152DV2", "V154DV2", "Vega 2024 Edition Subwoofers"],
    [["Vega Subwoofer Manual", "VEGA_SUBWOOFER_MANUAL.pdf"],
     ["Vega Series Subwoofer One Sheet", "VEGA_SERIES_SUBWOOFER_ONESHEET-compressed.pdf"]],
    {"V82DV2": [["V82DV2 One Sheet", "i_compressedi_One_Sheet-V82DV2.pdf"]],
     "V84DV2": [["V84DV2 One Sheet", "i_compressedi_One_Sheet-V84DV2.pdf"]],
     "V102DV2": [["V102DV2 One Sheet", "i_compressedi_One_Sheet-V102DV2.pdf"]],
     "V104DV2": [["V104DV2 One Sheet", "i_compressedi_One_Sheet-V104DV2.pdf"]],
     "V122DV2": [["V122DV2 One Sheet", "i_compressedi_One_Sheet-V122DV2.pdf"]],
     "V124DV2": [["V124DV2 One Sheet", "i_compressedi_One_Sheet-V124DV2.pdf"]],
     "V152DV2": [["V152DV2 One Sheet", "i_compressedi_One_Sheet-V152DV2.pdf"]],
     "V154DV2": [["V154DV2 One Sheet", "i_compressedi_One_Sheet-V154DV2.pdf"]]}],

  ["Subwoofer", "HED Subwoofers", ["H7104D", "H7104S", "H7124D", "H7124S", "HED 2024 Edition Subwoofers"],
    [["HED Subwoofer Manual", "HED_SUBWOOFER_MANUAL.pdf"],
     ["HED Series Subwoofer One Sheet", "HED_SERIES_SUBWOOFER_ONESHEET.pdf"],
     ["HED Subwoofer Owner's Manual (previous edition)", "HED_Subs_energy_Owner_s_Manual.pdf"]],
    {"H7104D": [["H7104D One Sheet", "i_compressedi_ONE_SHEET-H7104D.pdf"]],
     "H7104S": [["H7104S One Sheet", "i_compressedi_ONE_SHEET-H7104S.pdf"]],
     "H7124D": [["H7124D One Sheet", "i_compressedi_ONE_SHEET-H7124D.pdf"]],
     "H7124S": [["H7124S One Sheet", "i_compressedi_ONE_SHEET-H7124S.pdf"]]}],

  ["Subwoofer", "HED Slim / Shallow Subwoofers", ["HS102D", "HS104D", "HS122D", "HS124D", "HED Slim 2024 Edition"],
    [["HED Slim Subwoofer Manual", "HED_SLIM_SUBWOOFER_MANUAL.pdf"],
     ["HED Slim Series One Sheet", "HED_SLIM_SERIES_SUBWOOFER_ONESHEET.pdf"],
     ["HS Shallow Subwoofer Owner's Manual (previous edition)", "HS_SUBS_Shallow_Owner_s_Manual.pdf"]],
    {"HS102D": [["HS102D One Sheet", "i_compressedi_ONE_SHEET-HS102D.pdf"]],
     "HS122D": [["HS122D One Sheet", "i_compressedi_ONE_SHEET-HS122D.pdf"]]}],

  ["Subwoofer", "XED Subwoofers", ["XED10V2", "XED12V2"],
    [["XED Subwoofer Owner's Manual", "XED_Subs_Owner_s_Manual.pdf"]],
    {"XED10V2": [["XED10V2 One Sheet", "i_compressedi_ONE_SHEET-XED10V2.pdf"]],
     "XED12V2": [["XED12V2 One Sheet", "i_compressedi_ONE_SHEET-XED12V2.pdf"]]}],

  ["Subwoofer", "CVP Subwoofers", ["CVP10D4", "CVP10S4", "CVP12D4", "CVP12S4"],
    [["CVP Subwoofer Manual", "CVP_SUBWOOFERS_MANUAL.pdf"]],
    {"CVP10D4": [["CVP10D4 One Sheet", "CVP10D4_One_Sheet_updated_footer.pdf"]],
     "CVP10S4": [["CVP10S4 One Sheet", "CVP10S4_One_Sheet_updated_footer.pdf"]],
     "CVP12D4": [["CVP12D4 One Sheet", "CVP12D4_One_Sheet_updated_footer.pdf"]],
     "CVP12S4": [["CVP12S4 One Sheet", "CVP12S4_One_Sheet_updated_footer.pdf"]]}],

  ["Subwoofer", "Stroker Subwoofers", ["ST102D", "ST104D", "ST124D", "ST152D"],
    [["Stroker Subwoofer Owner's Manual", "Stroker_SUBS_Owner_s_Manual.pdf"],
     ["Stroker Series Subwoofer One Sheet", "Stroker_series_subwoofer_ONESHEET_b342604c-96a9-4962-8003-7ff7f6e811f1.pdf"]],
    {}],

  ["Subwoofer", "Stroker Pro Classic Subwoofers", ["SPCL152", "SPCL182"],
    [["Stroker Pro Classic Owner's Manual", "Stroker-Pro-Classic-Owner_s_Manual.pdf"]],
    {"SPCL152": [["SPCL152 One Sheet", "SPCL152.pdf"]],
     "SPCL182": [["SPCL182 One Sheet", "SPCL182_fceb5437-bdbf-4d20-999b-dba98a2f1b5a.pdf"]]}],

  ["Subwoofer", "VMAXX Subwoofers", ["VMAX65D2", "VMAX65D4", "VMAX8D2", "VMAX8D4", "VMAX10D2", "VMAX10D4", "VMAX12D2", "VMAX12D4", "VMAX15D2", "VMAX15D4", "VMAXS102", "VMAXS104", "VMAXS122", "VMAXS124"],
    [],
    {"VMAX65D2": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX65D2 One Sheet", "VMAX65D2_compressed.pdf"]],
     "VMAX65D4": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX65D4 One Sheet", "VMAX65D4_compressed_1.pdf"]],
     "VMAX8D2": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX8D2 One Sheet", "VMAX8D2_compressed.pdf"]],
     "VMAX8D4": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX8D4 One Sheet", "VMAX8D4_compressed.pdf"]],
     "VMAX10D2": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX10D2 One Sheet", "VMAX10D2_compressed.pdf"]],
     "VMAX10D4": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX10D4 One Sheet", "VMAX10D4_compressed.pdf"]],
     "VMAX12D2": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX12D2 One Sheet", "VMAX12D2_compressed_aa0f2c3f-3f56-4cb6-aaf5-cc78f7fd28a8.pdf"]],
     "VMAX12D4": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX12D4 One Sheet", "VMAX12D4_compressed.pdf"]],
     "VMAX15D2": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX15D2 One Sheet", "VMAX15D2_compressed.pdf"]],
     "VMAX15D4": [["VMAXX Subwoofer Owner's Manual", "VMAXX_Subwoofer_Owner_s_Manual.pdf"], ["VMAX15D4 One Sheet", "VMAX15D4_compressed.pdf"]],
     "VMAXS102": [["VMAXX Shallow Owner's Manual", "VMAXX-Shallow-Owner_s_Manual.pdf"], ["VMAXS102 One Sheet", "i_compressedi_One_Sheet-VMAXS102.pdf"]],
     "VMAXS104": [["VMAXX Shallow Owner's Manual", "VMAXX-Shallow-Owner_s_Manual.pdf"], ["VMAXS104 One Sheet", "i_compressedi_One_Sheet-VMAXS104.pdf"]],
     "VMAXS122": [["VMAXX Shallow Owner's Manual", "VMAXX-Shallow-Owner_s_Manual.pdf"], ["VMAXS122 One Sheet", "i_compressedi_One_Sheet-VMAXS122.pdf"]],
     "VMAXS124": [["VMAXX Shallow Owner's Manual", "VMAXX-Shallow-Owner_s_Manual.pdf"], ["VMAXS124 One Sheet", "i_compressedi_One_Sheet-VMAXS124.pdf"]]}],

  ["Subwoofer", "Vega Pro Shallow Subwoofers", ["VPS102D"],
    [["VPS Subwoofer Owner's Manual", "VPS_SUBS_Owner_s_Manual.pdf"]],
    {}],

  ["Subwoofer", "RPM Marine Subwoofers", ["RPM104SL", "RPM104FA"],
    [["RPM104SL / RPM104FA Manual", "RPM104SL-RPM104FA_MANUAL.pdf"]],
    {}],

  ["Subwoofer", "Vega Powered Subwoofers", ["VPAS12", "VPAS12ST", "VPSTX12", "VPAS68", "VPASV8", "VPAS821", "VPAS841", "VRAD10", "VR10"],
    [],
    {"VPAS12": [["VPAS12 Owner's Manual", "VPAS12_Owner_s_Manual.pdf"], ["VPAS12 One Sheet", "ONE_SHEET-VPAS12.pdf"]],
     "VPAS12ST": [["VPAS12ST Owner's Manual", "VPAS12ST-Owner_s_Manual.pdf"]],
     "VPSTX12": [["VPSTX12 Owner's Manual", "VPSTX12-Owner_s_Manual.pdf"], ["VPSTX12 One Sheet", "i_compressedi_ONE_SHEET-VPSTX12.pdf"]],
     "VPAS68": [["VPAS68 Owner's Manual", "VPAS68-Owner_s_Manual.pdf"], ["VPAS68 One Sheet", "i_compressedi_VPAS68_onesheet.pdf"]],
     "VPASV8": [["VPASV8 One Sheet", "VPASV8.pdf"]],
     "VPAS821": [["VPAS821 Manual", "i_compressedi_VPAS821-manual-Rev_1-9.8.pdf"], ["VPAS821 One Sheet", "VPAS821_ONESHEET.pdf"]],
     "VPAS841": [["VPAS841 Manual", "i_compressedi_VPAS841_-manual-Rev_2-12.26.2025.pdf"], ["VPAS841 One Sheet", "VPAS841_ONESHEET.pdf"]],
     "VRAD10": [["VRAD10 Owner's Manual", "VRAD10-Owner_s_Manual.pdf"], ["VRAD10 One Sheet", "VRAD10.pdf"]],
     "VR10": [["VR10 Owner's Manual", "VR10_Owner_s_Manual.pdf"], ["VR10 One Sheet", "i_compressedi_ONE_SHEET-VR10_1.pdf"]]}],

  ["Subwoofer", "HED Powered Subwoofers", ["H6TE10SV", "H6TE12SV", "H7SE10", "H7SE12"],
    [],
    {"H6TE10SV": [["H6TE10SV / H6TE12SV Owner's Manual", "H6TE10_12SV_Owner_s_Manual.pdf"], ["H6TE10SV One Sheet", "H6TE10SV.pdf"]],
     "H6TE12SV": [["H6TE10SV / H6TE12SV Owner's Manual", "H6TE10_12SV_Owner_s_Manual.pdf"], ["H6TE12SV One Sheet", "H6TE12SV.pdf"]],
     "H7SE10": [["H7SE10 / H7SE12 Manual", "H7SE10_H7SE12_Manual.pdf"], ["H7SE10 One Sheet", "i_compressedi_ONE_SHEET-H7SE10.pdf"]],
     "H7SE12": [["H7SE10 / H7SE12 Manual", "H7SE10_H7SE12_Manual.pdf"], ["H7SE12 One Sheet", "i_compressedi_ONE_SHEET-H7SE12.pdf"]]}],

  ["Subwoofer", "Spare Tire Subwoofers", ["VS12", "VS12SH"],
    [],
    {"VS12": [["VS12 Owner's Manual", "VS12_Owner_s_Manual.pdf"], ["VS12 One Sheet", "ONE_SHEET-VS12.pdf"]],
     "VS12SH": [["VS12SH Owner's Manual", "VS12SH_Owner_s_Manual.pdf"], ["VS12SH One Sheet", "ONE_SHEET-VS12SH.pdf"]]}],

  ["Subwoofer", "Subwoofer Enclosures & Bass Packages", ["XE10SV", "XE10DV", "XE12SV", "XE12DV", "H6E10SV", "H6E10DV", "H6E12SV", "H6E12DV", "BKX212V", "BKX212S"],
    [],
    {"XE10SV": [["XED Enclosures Owner's Manual", "XED-Enclosures-Owner_s_Manual.pdf"], ["XE10SV One Sheet", "i_compressedi_ONE_SHEET-XE10SV.pdf"]],
     "XE10DV": [["XED Enclosures Owner's Manual", "XED-Enclosures-Owner_s_Manual.pdf"], ["XE10DV One Sheet", "i_compressedi_ONE_SHEET-XE10DV.pdf"]],
     "XE12SV": [["XED Enclosures Owner's Manual", "XED-Enclosures-Owner_s_Manual.pdf"], ["XE12SV One Sheet", "i_compressedi_ONE_SHEET-XE12SV.pdf"]],
     "XE12DV": [["XED Enclosures Owner's Manual", "XED-Enclosures-Owner_s_Manual.pdf"], ["XE12DV One Sheet", "i_compressedi_ONE_SHEET-XE12DV.pdf"]],
     "H6E10SV": [["H6E10SV One Sheet", "i_compressedi_ONE_SHEET-H6E10SV.pdf"]],
     "H6E10DV": [["H6E10DV One Sheet", "i_compressedi_ONE_SHEET-H6E10DV.pdf"]],
     "H6E12SV": [["H6E12SV One Sheet", "i_compressedi_ONE_SHEET-H6E12SV.pdf"]],
     "H6E12DV": [["H6E12DV One Sheet", "i_compressedi_ONE_SHEET-H6E12DV.pdf"]],
     "BKX212V": [["BKX212V Owner's Manual", "BKX212V_Owner_s_Manual.pdf"], ["BKX212V One Sheet", "i_compressedi_ONE_SHEET-_BKX212V.pdf"]],
     "BKX212S": [["BKX212S Owner's Manual", "BKX212S_Owner_s_Manual.pdf"], ["BKX212S One Sheet", "i_compressedi_ONE_SHEET-_BKX212S.pdf"]]}],

  /* ============================ ACCESSORIES ============================ */
  ["Accessories", "Bass Processors & Enhancers", ["CVM0", "CVM1", "CVM2", "CVM3", "CVM4", "CVP2", "CVP3"],
    [],
    {"CVM0": [["CVM0 Manual", "CVM0-Manual.pdf"]],
     "CVM1": [["CVM1 Manual", "CVM1-Manual.pdf"]],
     "CVM2": [["CVM2 Manual", "CVM2-Manual.pdf"]],
     "CVM3": [["CVM3 Manual", "CVM3-Manual.pdf"]],
     "CVM4": [["CVM4 Manual", "CVM4_6-30-2023_Manual.pdf"]],
     "CVP2": [["CVP Series Enhancer Manual", "CVP_Series_Enhancer-manual-Rev_C.pdf"], ["CVP2 One Sheet", "CVP2-One_sheet.pdf"]],
     "CVP3": [["CVP Series Enhancer Manual", "CVP_Series_Enhancer-manual-Rev_C.pdf"], ["CVP3 One Sheet", "CVP3-One_sheet.pdf"]]}],

  ["Accessories", "Equalizers", ["EQP850", "EQ780"],
    [],
    {"EQP850": [["EQP850 Owner's Manual", "EQP850_Owner_s_Manual.pdf"]],
     "EQ780": [["EQ-780 Owner's Manual", "EQ-780_Owner_s_Manual.pdf"]]}],

  ["Accessories", "Line Output Converters", ["IOEM22", "IOEM24", "IOEM44", "IOEM66", "IOEM88", "IOEM8", "IOEMHL", "SLMLOC2", "SLMLOCT4"],
    [],
    {"IOEM22": [["IOEM22 / IOEM24 Owner's Manual", "IOEM22__24_Owner_s_Manual.pdf"], ["IOEM22 One Sheet", "IOEM22.pdf"]],
     "IOEM24": [["IOEM22 / IOEM24 Owner's Manual", "IOEM22__24_Owner_s_Manual.pdf"], ["IOEM24 One Sheet", "IOEM24.pdf"]],
     "IOEM44": [["IOEM44 Quick Guide", "IOEM44_Quick_Guide.pdf"]],
     "IOEM66": [["IOEM66 / IOEM88 Manual", "IOEM66-IOEM88_MANUAL.pdf"], ["IOEM66 One Sheet", "IOEM66.pdf"]],
     "IOEM88": [["IOEM66 / IOEM88 Manual", "IOEM66-IOEM88_MANUAL.pdf"], ["IOEM88 One Sheet", "IOEM88.pdf"]],
     "IOEM8": [["IOEM8 Manual", "IOEM8_Manual.pdf"]],
     "IOEMHL": [["IOEMHL Owner's Manual", "IOEMHL_Owner_s_Manual.pdf"]],
     "SLMLOC2": [["SLMLOC2 Owner's Manual", "SLMLOC2-Owner_s_Manual.pdf"]],
     "SLMLOCT4": [["SLMLOCT4 Owner's Manual", "SLMLOCT4-Owner_s_Manual.pdf"]]}],

  ["Accessories", "Bluetooth Receivers & Controllers", ["CVBTR", "CVBTR10", "BTR3", "BTR5", "BTR11", "BTR17"],
    [],
    {"CVBTR": [["CVBTR Owner's Manual", "CVBTR-Owner_s_Manual.pdf"]],
     "CVBTR10": [["CVBTR10 One Sheet", "CVBTR10.pdf"]],
     "BTR3": [["BTR3 Manual", "i_compressedi_Manual-BTR3-Rev_A.pdf"]],
     "BTR5": [["BTR5 Manual", "i_compressedi_Manual-BTR5-Rev_A.pdf"]],
     "BTR11": [["BTR11 Manual", "i_compressedi_Manual-BTR11-Rev_A.pdf"]],
     "BTR17": [["BTR17 Manual", "i_compressedi_Manual-BTR17-Rev_A.pdf"], ["BTR17 One Sheet", "BTR17.pdf"]]}],

  ["Accessories", "Media Players & Receivers", ["CMR3", "XMAP-1", "RPMHD14"],
    [],
    {"CMR3": [["CMR3 Manual", "CMR3-MANUAL-compressed.pdf"]],
     "XMAP-1": [["XMAP-1 Manual", "XMAP1-Manual.pdf"]],
     "RPMHD14": [["Plug-N-Play Media Receiver Manual", "PLUG_N-PLAY_MEDIA_RECEIVER_MANUAL.pdf"], ["RPMHD14 One Sheet", "RPMHD14_One-Sheet_v03.pdf"]]}],

  ["Accessories", "Harley-Davidson Kits", ["CMHR2 / CMHR4", "2024+ Cut-In Lid Kits"],
    [],
    {"CMHR2 / CMHR4": [["CMHR2 / CMHR4 Owner's Manual", "CMHR4_CMHR2-Owner_s_Manual.pdf"]],
     "2024+ Cut-In Lid Kits": [["2024+ Harley-Davidson Cut-In Lid Kits", "2024_HARLEY_cut_in_lid_kits_2025.pdf"]]}],

  ["Accessories", "Lighting Controllers", ["RPMDLED"],
    [],
    {"RPMDLED": [["RPMDLED Manual", "Manual-RPMDLED-Rev_A.pdf"]]}],

  ["Accessories", "Cameras", ["C400", "C480", "CLP1", "CLF1B", "CLF1C", "CRT1"],
    [],
    {"C400": [["C400 Manual", "C400_Manual.pdf"], ["C400 One Sheet", "C400.pdf"]],
     "C480": [["C480 Manual", "C480_Manual.pdf"], ["C480 One Sheet", "C480_One_Sheet.pdf"]],
     "CLP1": [["CLP1 One Sheet", "CLP1.pdf"]],
     "CLF1B": [["CLF1B One Sheet", "CLF1B.pdf"]],
     "CLF1C": [["CLF1C One Sheet", "CLF1C.pdf"]],
     "CRT1": [["CRT1 One Sheet", "CRT1.pdf"]]}],

  ["Accessories", "Bluetooth Speakers & Coolers", ["CV15BT", "CV62BM", "CV7BM", "CVC65R / CVC65B"],
    [],
    {"CV15BT": [["CV15BT Owner's Manual", "CV15BT_Owner_s_Manual.pdf"]],
     "CV62BM": [["CV62BM Manual", "CV62BM_Manual_compressed.pdf"]],
     "CV7BM": [["CV7BM Manual", "CV7BM_Manual_compressed.pdf"]],
     "CVC65R / CVC65B": [["CVC65R / CVC65B Manual", "CVC65R_CVC65B_Manual.pdf"]]}],

  ["Accessories", "RCA Cables", ["RH3", "RS1", "RV1"],
    [],
    {"RH3": [["RH3 One Sheet", "RH3.pdf"]],
     "RS1": [["RS1 One Sheet", "RS1.pdf"]],
     "RV1": [["RV1 One Sheet", "RV1.pdf"]]}]
];

window.onload = function () {
  var collectionSel = document.getElementById("collection"),
      seriesSel = document.getElementById("series"),
      modelSel = document.getElementById("model"),
      searchbar = document.getElementById("search"),
      resetManual = document.getElementById("reset-manual"),
      list = document.querySelector(".manuals .items") || document.querySelector(".items");
  if (!collectionSel || !seriesSel || !modelSel || !searchbar || !resetManual || !list) return;

  var OTHER = "Other Downloads";

  function fileOf(url) {
    return decodeURIComponent(String(url || "").split("?")[0].split("/").pop());
  }

  // 1. Flatten the catalog into one row per document.
  var rows = [];
  var known = {};
  (typeof CV_SKIP !== "undefined" ? CV_SKIP : []).forEach(function (f) { known[f] = true; });
  CV_MANUALS.forEach(function (e) {
    var c = e[0], s = e[1], models = e[2], seriesDocs = e[3] || [], modelDocs = e[4] || {};
    seriesDocs.forEach(function (d) {
      rows.push({ c: c, s: s, m: null, label: s, title: d[0], file: d[1], models: models });
      known[d[1]] = true;
    });
    Object.keys(modelDocs).forEach(function (m) {
      modelDocs[m].forEach(function (d) {
        rows.push({ c: c, s: s, m: m, label: m, title: d[0], file: d[1], models: [m] });
        known[d[1]] = true;
      });
    });
  });

  // 2. Keep anything already on the page that the catalog does not cover.
  Array.prototype.forEach.call(list.querySelectorAll(".item"), function (item) {
    var a = item.querySelector("a[href]");
    if (!a) return;
    var f = fileOf(a.getAttribute("href"));
    if (!f || known[f]) return;
    known[f] = true;
    var t = item.querySelector(".title");
    rows.push({ c: OTHER, s: OTHER, m: null, label: (item.firstElementChild || item).textContent.trim(),
                title: (t ? t.textContent : f).trim(), file: f, models: [] });
  });

  // 3. Render the list (same markup and classes the page already styles).
  list.innerHTML = "";
  rows.forEach(function (r) {
    var div = document.createElement("div");
    div.className = "item";
    var s1 = document.createElement("span"); s1.className = "series"; s1.textContent = r.label;
    var s2 = document.createElement("span"); s2.className = "title"; s2.textContent = r.title;
    var s3 = document.createElement("span"); s3.className = "download";
    var a = document.createElement("a");
    a.href = /^https?:/.test(r.file) ? r.file : CV_FILES + encodeURIComponent(r.file);
    a.target = "_blank"; a.rel = "noopener"; a.textContent = " Download ";
    s3.appendChild(a);
    div.appendChild(s1); div.appendChild(document.createTextNode(" "));
    div.appendChild(s2); div.appendChild(document.createTextNode(" "));
    div.appendChild(s3);
    div._row = r;
    div._text = (r.c + " " + r.s + " " + r.label + " " + r.title + " " + r.models.join(" ") + " " + r.file).toLowerCase();
    list.appendChild(div);
  });

  var items = Array.prototype.slice.call(list.getElementsByClassName("item"));

  function show(test) {
    items.forEach(function (el) { el.style.display = test(el._row, el) ? "block" : "none"; });
  }

  function collections() {
    var out = [];
    rows.forEach(function (r) { if (out.indexOf(r.c) === -1) out.push(r.c); });
    return out;
  }
  function seriesOf(c) {
    var out = [];
    rows.forEach(function (r) { if (r.c === c && out.indexOf(r.s) === -1) out.push(r.s); });
    return out;
  }
  function modelsOf(c, s) {
    for (var i = 0; i < CV_MANUALS.length; i++) {
      if (CV_MANUALS[i][0] === c && CV_MANUALS[i][1] === s) return CV_MANUALS[i][2].slice();
    }
    return [];
  }

  collections().forEach(function (c) {
    collectionSel.options[collectionSel.options.length] = new Option(c, c);
  });

  collectionSel.onchange = function () {
    var c = this.value;
    seriesSel.length = 1;
    modelSel.length = 1;
    searchbar.value = "";
    seriesOf(c).forEach(function (s) { seriesSel.options[seriesSel.options.length] = new Option(s, s); });
    show(function (r) { return !c || r.c === c; });
  };

  seriesSel.onchange = function () {
    var c = collectionSel.value, s = this.value;
    modelSel.length = 1;
    modelsOf(c, s).forEach(function (m) { modelSel.options[modelSel.options.length] = new Option(m, m); });
    show(function (r) { return r.c === c && (!s || r.s === s); });
  };

  modelSel.onchange = function () {
    var c = collectionSel.value, s = seriesSel.value, m = this.value;
    show(function (r) { return r.c === c && r.s === s && (!m || r.m === null || r.m === m); });
  };

  searchbar.onkeyup = function (e) {
    var term = e.target.value.toLowerCase().trim();
    show(function (r, el) { return !term || el._text.indexOf(term) !== -1; });
  };

  resetManual.onclick = function () {
    seriesSel.length = 1;
    modelSel.length = 1;
    searchbar.value = "";
    show(function () { return true; });
  };
};